export default {
  setUserGroupsList: (state, userGroupsList) => { state.userGroupsList = userGroupsList },
  setUserGroupDetails: (state, data) => { state.userGroupDetails = data },
  setTrackingGroups: (state, trackingGroups) => { state.trackingGroups = trackingGroups },
  setBenefitGroups: (state, benefitGroups) => { state.benefitGroups = benefitGroups },
  setParentGroups: (state, parentGroups) => { state.parentGroups = parentGroups },
  setGroupSummary: (state, groupSummary) => { if (groupSummary) groupSummary.forEach(e => e.expanded = false); state.groupSummary = groupSummary }
}
